import graphql from 'api/graphql'
import { oauthTokenSelector } from 'selectors/app'
import { BootstrapLoader } from 'util/bootstrap'
import { billingQuery } from '../api'
import {
  FETCH_BILLING_REQUEST,
  FETCH_BILLING_FAIL,
  FETCH_BILLING_SUCCESS,
} from '../types'

export function createFetchBillingRequestAction() {
  return { type: FETCH_BILLING_REQUEST }
}

export function createFetchBillingFailAction(error) {
  return { type: FETCH_BILLING_FAIL, data: { error } }
}

export function createFetchBillingSuccessAction(response) {
  const {
    json: { data },
  } = response
  return { type: FETCH_BILLING_SUCCESS, data: { ...data } }
}

export function createFetchBillingLoader() {
  return new BootstrapLoader(
    'billing',
    createFetchBillingRequestAction,
    createFetchBillingSuccessAction,
    createFetchBillingFailAction,
    getState => {
      return graphql(oauthTokenSelector(getState()), billingQuery())
    }
  )
}
